import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { userNewPasswordSchema } from "validation";
import { Button, PasswordInput } from "components/global";
import Image from "next/image";
import Link from "next/link";
import { toast } from "react-toastify";
import axiosInstance from "helper/apis/axiosInstance";
import PropTypes from "prop-types";

export default function NewPasswordForm({ token }) {

	const [success, setSuccess] = useState(false)
	const [error, setError] = useState(null)
	const [isMutating, setIsMutating] = useState(false)


	// Handle new password submission
	const onSubmitPassword = async (values) => {

		try {
			setIsMutating(true)
			await axiosInstance.patch(`/auth/resetPassword`, {
				password: values.password,
			}, {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`
				}
			});
			setSuccess(true);
			toast.success("تم تغيير كلمة المرور بنجاح");
			// Redirect or show success message
		} catch (err) {
			// Error is handled by useApiMutation
			toast.error(err?.message || "حدث خطأ ما أثناء تغيير كلمة المرور");
			setError(err?.message)
		} finally {
			setIsMutating(false)
		}
	};

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: zodResolver(userNewPasswordSchema),
	});

	return (
		<>
			{!success ? <form className="flex flex-col gap-4 mt-6 mx-auto container md:max-w-2xl" onSubmit={handleSubmit(onSubmitPassword)} noValidate>
				<PasswordInput
					label="كلمة المرور"
					name="password"
					placeholder="كلمة المرور"
					required
					register={register}
					error={errors.password}
				/>

				<PasswordInput
					label="تأكيد كلمة المرور"
					name="confirmPassword"
					placeholder="تأكيد كلمة المرور"
					required
					register={register}
					error={errors.confirmPassword}
				/>

				{/* Display API Error Message */}
				{error && <p className="text-red-600 text-lg mt-1">{error.message}</p>}

				<Button
					isLoading={isMutating}
					disabled={isMutating}
				>
					حفظ
				</Button>


			</form> : <div className="flex flex-col justify-center items-center pt-10 gap-6 px-6">
				<Image
					alt="success"
					src="/icons/success.svg"
					width={200}
					height={200}
				/>
				<p className="text-lg text-gray-900">تم تغيير كلمة المرور بنجاح.</p>
				<Link href="/login">
					<a className="w-full">
						<Button>تسجيل الدخول</Button>
					</a>
				</Link>
			</div>
			}
		</>
	);
}

NewPasswordForm.propTypes = {
	token: PropTypes.string.isRequired,
};

